import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core'
import { IRarHelper, RarCodes } from '@exchange/domain/lookups'
import {
  ClaimLineRemittanceAdviceODataService,
  IClaimLineRemittanceAdvice,
  IClaimLineView
} from '@exchange/domain/.'
import {
  ActionButtonsColumnRendererComponent,
  GridSize,
  GridWrapperComponent,
  SingleRowSelection
} from 'common-components'
import { ColDef } from 'ag-grid-community'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'

@Component({
  selector: 'app-response-codes-remittance-remarks',
  templateUrl: './response-codes-remittance-remarks.component.html',
  standalone: false
})
export class ResponseCodesRemittanceRemarksComponent implements OnInit, AfterViewInit {
  @ViewChild('selectedRarCodeList', { static: true }) selectedRarCodeList: GridWrapperComponent

  @Input() claimLineView: IClaimLineView

  GridSize = GridSize
  RarCodes = RarCodes.Codes

  constructor(
    private odata: ClaimLineRemittanceAdviceODataService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.initializeSelectedList()
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.selectedRarCodeList.api.autoSizeAllColumns()
    }, 1)
  }

  removeRarCode(item: IClaimLineRemittanceAdvice) {
    this.odata
      .delete(item.Id)
      .exec()
      .subscribe(response => {
        this.selectedRarCodeList.getData()
      })
  }

  initializeSelectedList() {
    const cols: ColDef[] = [
      {
        headerName: '',
        field: 'Actions',
        pinned: 'left',
        width: 100,
        cellRenderer: ActionButtonsColumnRendererComponent
      },
      {
        headerName: 'Code',
        field: 'Code',
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 50,
        cellRenderer: GridWrapperComponent.TooltipRenderer()
      },
      {
        headerName: 'Description',
        field: 'Code',
        menuTabs: [],
        sortable: false,
        width: 300,
        cellRenderer: (params: any) => {
          const code = this.RarCodes.find(x => x.code === params.value)
          return code ? code.description : ''
        }
      }
    ]

    if (!this.canEditRemittanceRemarks()) {
      cols.shift()
    }

    this.selectedRarCodeList.gridOptions.context = {
      canEdit: false,
      canDelete: this.canEditRemittanceRemarks(),
      deleteHandler: this.removeRarCode.bind(this)
    }

    this.selectedRarCodeList.gridOptions.columnDefs = cols
    this.selectedRarCodeList.gridOptions.rowSelection = SingleRowSelection
    this.selectedRarCodeList.defaultFilter = `ServiceId eq ${this.claimLineView.ServiceId}`
    this.selectedRarCodeList.odata = this.odata
  }

  canAddRarCode() {
    return this.selectedRarCodeList.data && this.selectedRarCodeList.data.length < 99
  }

  showAddModal() {
    this.modalService.show(AddRemittanceRemarksModalComponent, {
      initialState: {
        selectedRarCodeListData: this.selectedRarCodeList.data,
        doSelect: this.doSelect
      },
      class: 'modal-lg'
    })
  }

  doSelect = (rarModalGridSelection: IRarHelper, callback: () => void) => {
    if (rarModalGridSelection) {
      const record = {
        ClaimId: this.claimLineView.ClaimId,
        ServiceId: this.claimLineView.ServiceId,
        Code: rarModalGridSelection.code
      } as IClaimLineRemittanceAdvice

      this.odata
        .post(record)
        .exec()
        .subscribe(response => {
          this.selectedRarCodeList.getData()
          callback()
        })
    }
  }

  canEditRemittanceRemarks() {
    const notAllowed = ['Pending Remit', '837 Out']
    return notAllowed.indexOf(this.claimLineView.Status) === -1
  }
}

@Component({
  templateUrl: './add-remittance-remark-modal.component.html',
  standalone: false
})
export class AddRemittanceRemarksModalComponent implements OnInit {
  @ViewChild('rarModalGrid', { static: true }) rarModalGrid: GridWrapperComponent
  rarModalGridSelection: IRarHelper = null

  selectedRarCodeListData: any
  doSelect: (rarModalGridSelection: IRarHelper, callback: () => void) => void

  GridSize = GridSize
  RarCodes = RarCodes.Codes
  constructor(public modalRef: BsModalRef) {}

  ngOnInit(): void {
    this.initializeCodeList()
  }

  isRowSelectable(rowNode) {
    return (
      this.selectedRarCodeListData &&
      !this.selectedRarCodeListData.find(x => x.Code === rowNode.data.code)
    )
  }

  initializeCodeList() {
    const rarCols = [
      {
        headerName: 'Code',
        field: 'code',
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 50,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        cellStyle: rowNode => (!this.isRowSelectable(rowNode) ? { color: 'silver' } : {})
      },
      {
        headerName: 'Description',
        field: 'description',
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 300,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        cellStyle: rowNode => (!this.isRowSelectable(rowNode) ? { color: 'silver' } : {})
      }
    ]

    this.rarModalGrid.hasPagination = false
    this.rarModalGrid.gridOptions.columnDefs = rarCols
    this.rarModalGrid.gridOptions.rowSelection = SingleRowSelection

    this.rarModalGrid.gridOptions.onSelectionChanged = () => {
      this.rarModalGridSelection = this.rarModalGrid.api.getSelectedRows()[0]
    }

    this.rarModalGrid.gridOptions.isRowSelectable = this.isRowSelectable.bind(this)
    this.rarModalGrid.data = this.RarCodes
  }

  select = () => {
    this.doSelect(this.rarModalGridSelection, () => {
      this.rarModalGridSelection = null
      this.modalRef.hide()
    })
  }
}
